import { Divider, Modal } from "antd";
import axios from "axios";
import "./style.css";

import { useState } from "react";
import { number_3_3 } from "../../../utilities";

import { api } from "../../../api/url";
import Button from "../../Button";

const ConfirmVisitComponent = (props) => {
  const [loading, setLoading] = useState(false);

  const handleOk = () => {
    props.setOpen(false);
  };
  const handleCancel = () => {
    props.setOpen(false);
  };

  const ValidateTime = async () => {
    setLoading(true);
    axios({
      method: "get",
      url:
        api +
        "appointment/validateschedule/" +
        props?.active_time?.attenderScheduleBlockId,
    })
      .then((res) => {
        if (res.data.data === false) {
          ConfirmTime();
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  // ---- TODO :confirm she ina
  const ConfirmTime = async () => {
    await axios({
      method: "post",
      url: api + "appointment/admission/save",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: {
        attenderId: props.visitInfo.attenderId,
        serviceId: props.visitInfo.serviceId,
        attenderScheduleBlockId: props?.active_time?.attenderScheduleBlockId,
        reserveNo: props?.active_time?.reserveNo,
        reserveDatePersian: props?.active_date?.appointmentDatePersian, //?
        reserveTime: props?.active_time?.startTime, //?
        companyId: props?.visitInfo?.companyId,
        branchId: props.visitInfo.branchId,
        userId: localStorage.getItem("user"),
        patientUserMobileNo: localStorage.getItem("cellphone"),
        patientUserFirstName: props?.visitInfo?.userFirstName,
        patientUserLastName: props?.visitInfo?.userLastName,
        patientUserNationalCode: props?.visitInfo?.userNationalCode,
        patientUserGenderId: 1,
        // terminalNo: "string",
      },
    })
      .then((res) => {
        setLoading(false);
        window.location.href = "/profile/history";
      })
      .catch((err) => {
        alert("خطا در ثبت");
        console.log("err", err);
      });
  };

  return (
    <Modal
      open={props.open}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      // width={420}
    >
      <div className="visit-modal-confirm">
        <h4>تایید پذیرش</h4>
        <div className="visit-modal-confirm-content">
          <div className="row">
            <div className="col-lg-6 col-6 ">نام‌و‌نام‌خانوادگی:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {props.visitInfo?.userFullName}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 ">
              کدملی: {props.visitInfo?.userNationalCode}
            </div>
            <div className="col-lg-6 visit-modal-left">
              شماره‌تماس: {localStorage.getItem("cellphone")}
            </div>
          </div>

          <Divider />
          <div className="row">
            <div className="col-lg-6 ">
              {" "}
              نام‌پزشک: {props.visitInfo?.attenderFullName}
            </div>
            <div className="col-lg-6 visit-modal-left">
              تخصص: {props.visitInfo?.attenderSpecialityName}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 ">
              شماره تماس: {props.visitInfo?.branchPhoneNo}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 ">
              آدرس: {props.visitInfo?.branchAddress}{" "}
            </div>
          </div>
          <Divider />
          <div className="row">
            <div className="col-lg-6 col-6 ">
              {" "}
              تاریخ: {props.active_date?.appointmentDatePersian}
            </div>
            <div className="col-lg-6 col-6 visit-modal-left">
              ساعت:{" "}
              {props.active_time?.endTime + "-" + props.active_time?.startTime}
            </div>
          </div>
          <Divider />
          {props.visitInfo.cashAmountList.map((item) => (
            <div className="row">
              <div className="col-lg-6  col-6">مبلغ قابل پرداخت:</div>
              <div className="col-lg-6 col-6 visit-modal-left">
                {number_3_3(item.price)} ریال
              </div>
            </div>
          ))}
        </div>

        <Button
          isSubmitting={loading}
          onClick={() => ValidateTime()}
          className="modal-phonenumber-container-button"
        >
          تایید و پرداخت
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmVisitComponent;
